module.exports = {
  PACK_0: 'pack-0',
  PACK_1: 'pack-1',
  PACK_2: 'pack-2',
  PACK_3: 'pack-3',
  PACK_5: 'pack-5',
  PUBLIC_DELEGATION: 'public-delegation',
  CHARGE_MY_CAR: 'charge-my-car',
};
